(() => {
 const init = (scope = document) => scope.querySelectorAll('[data-vn-quiz]').forEach(root => {
  if(root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form=root.querySelector('[data-quiz-form]'), steps=[...root.querySelectorAll('[data-quiz-step]')], next=root.querySelector('[data-quiz-next]'), back=root.querySelector('[data-quiz-back]'), result=root.querySelector('[data-quiz-result]'), progress=root.querySelector('[data-quiz-progress]');
  const productUrl=root.querySelector('[data-quiz-product]').getAttribute('href');
  let step=0;
  const selected=n=>form.querySelector(`input[name="guide-${n}"]:checked`);
  const show=(focus=true)=>{
   steps.forEach((el,i)=>el.hidden=i!==step);
   root.querySelector('[data-quiz-number]').textContent=String(step+1);
   root.querySelectorAll('.vn-quiz-bars span').forEach((el,i)=>el.classList.toggle('is-complete',i<=step));
   next.disabled=!selected(step+1);back.hidden=step===0;
   root.querySelector('[data-quiz-next-text]').textContent=root.querySelector(step===2?'[data-quiz-finish]':'[data-quiz-continue]').textContent;
   if(focus) steps[step].querySelector('legend').focus();
  };
  next.hidden=true;
  form.addEventListener('click',event=>{if(event.target.matches('input[type="radio"]')&&event.target.checked){next.disabled=false;form.requestSubmit();}});
  back.addEventListener('click',()=>{step=Math.max(0,step-1);show();});
  form.addEventListener('submit',event=>{
   event.preventDefault();if(!selected(step+1)) return;
   if(step<2){step++;show();return;}
   const material=selected(1).value, condition=selected(2).value, color=selected(3);
   const outcome=material==='fabric'||condition==='flaking'?'bad':material==='unknown'||condition==='unsure'?'check':'good';
   root.querySelectorAll('[data-quiz-outcome]').forEach(el=>el.hidden=el.dataset.quizOutcome!==outcome);
   const chosen=color.value!=='unsure';
   root.querySelector('[data-quiz-color]').hidden=outcome!=='good'||!chosen;
   root.querySelector('[data-quiz-color-none]').hidden=outcome!=='good'||chosen;
   root.querySelector('[data-quiz-color-name]').textContent=chosen?color.dataset.color:'';
   const photo=root.querySelector('[data-quiz-photo]');photo.hidden=!chosen;
   if(chosen){photo.src=color.dataset.image;photo.alt=color.dataset.color;}
   const link=root.querySelector('[data-quiz-product]');link.hidden=outcome!=='good';
   link.href=chosen?color.dataset.url:productUrl;
   root.querySelector('[data-quiz-contact]').classList.toggle('button',outcome!=='good');
   form.hidden=true;progress.hidden=true;result.hidden=false;result.focus();
  });
  root.querySelector('[data-quiz-restart]').addEventListener('click',()=>{form.reset();step=0;result.hidden=true;form.hidden=false;progress.hidden=false;show();});
  root.querySelector('[data-quiz-fallback]').hidden=true;form.hidden=false;progress.hidden=false;show(false);
 });
 init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
